import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["className", "value", "error", "warning", "filterOption"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _noop from 'lodash/noop';
import _toLower from 'lodash/toLower';
import _isFunction from 'lodash/isFunction';
import { EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import Error from '../../components/error';
import FieldLabel from '../../components/fieldLabel';
import ACTION_TYPES from '../../constants/actionTypes';
import styles from './withSelectInput.module.scss';
var DEFAULT_OPTIONS = {
  useFilterOption: true
};
var defaultStringify = function defaultStringify(option) {
  var label = option.label,
    value = option.value;
  var optionString = "".concat(label, " ").concat(value);
  return optionString.toLowerCase();
};
var defaultFilterOption = function defaultFilterOption() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var searchText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var label = option.label,
    _option$data = option.data,
    data = _option$data === void 0 ? EMPTY_OBJECT : _option$data;
  var __isNew__ = data.__isNew__;
  if (!label || searchText === '') {
    return true;
  }
  var optionString = __isNew__ ? defaultStringify(option) : _toLower(label);
  return optionString.includes(searchText.toLocaleLowerCase());
};
var withSelectInput = function withSelectInput(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;
  var WithSelectInput = /*#__PURE__*/function (_PureComponent) {
    _inherits(WithSelectInput, _PureComponent);
    var _super = _createSuper(WithSelectInput);
    function WithSelectInput() {
      var _this;
      _classCallCheck(this, WithSelectInput);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "handleChange", function (value) {
        var _this$props = _this.props,
          id = _this$props.id,
          onAction = _this$props.onAction;
        onAction({
          type: ACTION_TYPES.ON_FIELD_CHANGE,
          payload: _objectSpread({
            id: id
          }, value)
        });
      });
      _defineProperty(_assertThisInitialized(_this), "handleBlur", function (action) {
        var _this$props2 = _this.props,
          id = _this$props2.id,
          onAction = _this$props2.onAction;
        onAction({
          type: ACTION_TYPES.ON_FIELD_BLUR,
          payload: {
            id: id,
            action: action
          }
        });
      });
      return _this;
    }
    _createClass(WithSelectInput, [{
      key: "renderSelectBox",
      value: function renderSelectBox() {
        var _classNames;
        var _this$props3 = this.props,
          className = _this$props3.className,
          value = _this$props3.value,
          error = _this$props3.error,
          warning = _this$props3.warning,
          option = _this$props3.filterOption,
          otherProps = _objectWithoutProperties(_this$props3, _excluded);
        var classes = classNames('flex-auto-grow-shrink full-width', (_classNames = {}, _defineProperty(_classNames, error, error), _defineProperty(_classNames, className, className), _classNames));
        var filterOption = options.useFilterOption ? option || defaultFilterOption : undefined;
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, otherProps, {
          className: classes,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          value: value,
          hasError: !!error,
          filterOption: filterOption
        }));
      }
    }, {
      key: "render",
      value: function render() {
        var props = this.props;
        var renderError = props.renderError,
          error = props.error,
          value = props.value,
          warning = props.warning,
          className = props.className,
          fieldClassName = props.fieldClassName;
        return /*#__PURE__*/React.createElement("div", _extends({
          className: "fieldC ".concat(className, "  ").concat(fieldClassName, " ")
        }, props.fieldLevelDataAttributes), /*#__PURE__*/React.createElement(FieldLabel, props), this.renderSelectBox(), _isFunction(renderError) ? renderError({
          error: error,
          value: value
        }) : /*#__PURE__*/React.createElement(Error, props), !error && warning && /*#__PURE__*/React.createElement(Error, {
          error: warning,
          className: styles.warningMessage
        }));
      }
    }]);
    return WithSelectInput;
  }(PureComponent);
  WithSelectInput.propTypes = {
    className: PropTypes.string,
    error: PropTypes.bool,
    fieldClassName: PropTypes.string,
    id: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    warning: PropTypes.string,
    label: PropTypes.string,
    onAction: PropTypes.func,
    menuPortalTarget: PropTypes.node,
    menuPosition: PropTypes.string,
    menuPlacement: PropTypes.string,
    renderError: PropTypes.func,
    placeholder: PropTypes.string
  };
  WithSelectInput.defaultProps = {
    menuPortalTarget: document.body,
    menuPosition: 'fixed',
    menuPlacement: 'auto',
    className: EMPTY_STRING,
    error: false,
    warning: null,
    fieldClassName: EMPTY_STRING,
    label: EMPTY_STRING,
    onAction: _noop,
    value: EMPTY_STRING,
    renderError: undefined,
    placeholder: __('Select')
  };
  return WithSelectInput;
};
export default withSelectInput;